import { useLayoutEffect } from 'react';
import { isSSR } from '../misc/is_ssr';

/**
 * ## @cellula/react
 *
 * `useLayoutEffect` is not meant to run on the server. To suppress any
 * warnings, this hook will just no-op on the server.
 *
 * See: https://reactjs.org/docs/hooks-reference.html#uselayouteffect
 */
export const useSsrSafeLayoutEffect = (
	!isSSR
		? useLayoutEffect
		: () => {
				// noop
			}
) as typeof useLayoutEffect;
